module.exports = __webpack_public_path__ + "static/media/hiw11.6e86de54.svg";